import {  Grid, Box, Typography } from "@mui/material"
import MethodButton from "./MethodButton";


const RecoverMethodView = ({
    onSelectedMethod,
    disabled_email
}) => {

    return(
        <Box
            sx={{fontFamily: (theme) => theme.typography.fontFamily}}
        >
            <Typography variant='h5' style={{fontWeight:600}}>Recupera tu contraseña</Typography>
            <Box sx={{mt:5}}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <MethodButton 
                            type='mobile'
                            onClick={() => onSelectedMethod('mobile')}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <MethodButton
                            type='whatsapp'
                            onClick={() => onSelectedMethod('whatsapp')}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <MethodButton 
                            disabled={disabled_email}
                            type='email'
                            onClick={() => onSelectedMethod('email')}
                        />
                    </Grid>
                    
                </Grid>
            </Box>
            <div style={{height:100}}/>
            <div style={{height:40}}/>
        </Box>
    )
}

export default RecoverMethodView